var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:none;stroke:#006DF0;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#37CE93;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#006DF0;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#006DF0;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:#006DF0;}\n\t.st6{fill:#37CE93;}\n\t.st7{fill:none;stroke:#006DF0;stroke-width:3;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#37CE93;stroke-width:3;stroke-miterlimit:10;}\n\t.st9{fill:none;stroke:#006DF0;stroke-width:2.5;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st10{fill:none;stroke:#006DF0;stroke-width:3;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.74,88.32c-0.1,1.41-1.27,2.53-2.7,2.53H6.82c-1.41,0-2.56-1.08-2.7-2.46c-1.19,0.55-1.83,1.13-1.83,1.73 c0,3.48,21.36,6.31,47.71,6.31s47.71-2.82,47.71-6.31C97.71,89.5,97.02,88.89,95.74,88.32z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.01,
    y: 21.11,
    className: "st1",
    width: 35.65,
    height: 22.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 32.01,
    y1: 32.31,
    x2: 67.66,
    y2: 32.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 49.83,
    y1: 43.52,
    x2: 49.83,
    y2: 21.88
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M41.69,88.2h-8.77V78.04c0-2.16,1.75-3.91,3.91-3.91h0.94c2.16,0,3.91,1.75,3.91,3.91V88.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.07,88.2h-8.77V78.04c0-2.16,1.75-3.91,3.91-3.91h0.94c2.16,0,3.91,1.75,3.91,3.91V88.2z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 41.69,
    y1: 80.04,
    x2: 58.31,
    y2: 80.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.31,74.12v-6.67c0-3.69,2.99-6.69,6.69-6.69H56c3.69,0,6.69,2.99,6.69,6.69v6.35"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.38,84.05V61.44v-2.57c0-6.67-1.06-9.66-4.83-9.66h0c-2.72,0-4.07,1.59-5.17,3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77.59,88.13c0-1.84,1.82-3.34,4.07-3.34h3.43c2.25,0,4.07,1.49,4.07,3.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M71.81,59.64l-4.39-4.39l2.13-2.13c1.08-1.08,2.83-1.08,3.92,0l0.47,0.47c1.08,1.08,1.08,2.83,0,3.92 L71.81,59.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M67.49,50.18c1.24-1.33,3-1.76,4.6-1.33v-5.33c0-0.83-0.67-1.5-1.5-1.5H29.42c-0.83,0-1.5,0.67-1.5,1.5v6.3 c0,0.83,0.67,1.5,1.5,1.5h37.01L67.49,50.18z M30.92,45.02h38.17v3.3H30.92V45.02z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "12.83,89.32 12.83,72.45 25.41,72.45 25.41,89.32  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 12.83,
    y1: 81.16,
    x2: 25.41,
    y2: 81.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 17.4,
    y1: 76.64,
    x2: 20.84,
    y2: 76.64
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.61,
    y: 7.57,
    className: "st1",
    width: 88.79,
    height: 81.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 6.34,
    y1: 14.39,
    x2: 94.39,
    y2: 14.39
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoom);
export default __webpack_public_path__ + "static/media/Room.efdb268ba899ca7bb7c3e918fce8def5.svg";
export { ForwardRef as ReactComponent };